// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {616: "3d4cf0b67d15991c",822: "8828f3b8422603fc",}[chunkId] + ".css"
}